import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import {
  Box,
  Typography,
  IconButton,
  GlobalStyles
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const PREFIX = process.env.PUBLIC_URL + "/clients/";

/* =========================
   ALL CLIENT LOGOS
========================= */
const logoList = [
  "abb.png","adani.png","adnoc.png","agip.png","aig.png","aker.png",
  "APGENCO.png","bANDR.png","bechtel.png","bpcl.png","british.png",
  "cairn.png","CLG.png","clough.png",
  "DVC._LOGO.png","eil.png","essar.png","FMC.png",
  "gail.png", "HNPCL.LOGO.png","GSECL.LOGO.png","gujaratgas.png",
  "GE_POWER.png",,"Honeywell.png","HPCL.png","kbr.png","kpcl.png",
  "mahagenco.png","maire.png","mcdermott.png","mppgcl.png","npcil.png",
  "ntpc.png","ntpl.png","petrofac.png","pvun.png","QatarGas.png",
  "samsung.png","siemens.png",
  "SJVN.LOGO.png","tangedco.png","tatapower.png","technip.png",
  "THDC.LO.png","thyssenkrupplogo.png","TOSHIBA.png","toyota.png",
  "tsgenco.png","UPRVUNIL.png","wbpdcl.png",
  "wte.png","DRAGONOIL.LOGO.png"
];

export default function ClientsSlider() {
  const sliderRef = useRef(null);
  const [logos, setLogos] = useState([]);

  useEffect(() => {
    setLogos(logoList);
  }, []);

  /* =========================
     SLIDER SETTINGS
  ========================= */
  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2200,
    speed: 700,
    arrows: false,
    slidesToShow: 5,   // 👈 reduced so logos can be slightly bigger
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 4 } },
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 900,  settings: { slidesToShow: 3 } },
      { breakpoint: 600,  settings: { slidesToShow: 2 } }
    ]
  };

  return (
    <>
      {/* =========================
         GLOBAL STYLES (SPACING FIX)
      ========================= */}
      <GlobalStyles
        styles={{
          ".clients-slider .slick-slide": {
            padding: "0 40px",
            boxSizing: "border-box"
          },
          ".clients-slider .slick-list": {
            margin: "0 -40px"
          }
        }}
      />

      <Box
        id="clients"
        className="clients-slider"
        sx={{
          py: { xs: 6, md: 8 },
          px: { xs: 2, sm: 4, md: 8, lg: "250px" },

          backgroundColor: "#F7FAFF",
          textAlign: "center"
        }}
      >
        {/* TITLE */}
        <Typography
          variant="h4"
          fontWeight={700}
          sx={{ color: "#2d2075", mb: 1 }}
        >
          Clients
        </Typography>

        <Box
          sx={{
            width: 90,
            height: 3,
            backgroundColor: "#2d2075",
            mx: "auto",
            mb: 6
          }}
        />

        {/* =========================
           SLIDER WITH CENTERED ARROWS
        ========================= */}
        <Box sx={{ position: "relative", width: "100%" }}>
          
          {/* LEFT ARROW */}
          <IconButton
            onClick={() => sliderRef.current?.slickPrev()}
            sx={{
              position: "absolute",
              left: { xs: -8, md: -28 },
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 2,
              display: { xs: "none", md: "flex" },
              backgroundColor: "#ffffff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
            }}
          >
            <ArrowBackIosNewIcon fontSize="small" />
          </IconButton>

          {/* SLIDER */}
          <Slider ref={sliderRef} {...settings}>
            {logos.map((file, index) => (
              <Box
                key={index}
                sx={{
                  height: 140,   // 👈 more vertical space
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                {/* LOGO BOX — SLIGHTLY BIGGER */}
                <Box
                  sx={{
                    width: 180,  // 👈 increased from 160
                    height: 100,  // 👈 increased from 60
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <img
                    src={PREFIX + file}
                    alt={file}
                    loading="lazy"
                    style={{
                      maxWidth: "100%",
                      maxHeight: "100%",
                      objectFit: "contain"
                    }}
                  />
                </Box>
              </Box>
            ))}
          </Slider>

          {/* RIGHT ARROW */}
          <IconButton
            onClick={() => sliderRef.current?.slickNext()}
            sx={{
              position: "absolute",
             right: { xs: "-40px", md: "-60px", lg: "-80px" },
              top: "50%",
              transform: "translateY(-50%)",
              zIndex: 2,
              display: { xs: "none", md: "flex" },
              backgroundColor: "#ffffff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
            }}
          >
            <ArrowForwardIosIcon fontSize="small" />
          </IconButton>

        </Box>
      </Box>
    </>
  );
}
